import {Injectable} from '@angular/core';
import {AppService} from "./app.service";
import {TranslateService} from './translate/translate.service';
import {ApiConnection, CiCo, Day, PfCiCoResource, PfDayResource, PfItemResource, PfUserResource} from 'pfapi';
import {PfUserIndexResource} from "./resources/pfuserindexresource";

@Injectable()
export class ContentService {
  protected apiConnection: ApiConnection;

  constructor(private appService: AppService, private _translate: TranslateService) {
    console.log('ContentService Initialized...');
    this.appService.setResizeIsOk(true);
    this.apiConnection = this.appService.getApiConnection();
  }

  public getAppService(){
    return this.appService;
  }

  public cico(username?: string, forcedState?: boolean): Promise<CiCoInfo> {
    return new Promise ((resolve, reject) => {
      let user;
      let isCheckedIn: boolean;
      let ciCoInfoGeneral = new CiCoInfo;
      if (navigator.onLine == true) {
        const rfidInput = <HTMLInputElement>document.getElementById("rfidInput");
        let chipID = null;
        if (rfidInput) {
          chipID = rfidInput.value;    // inputfeld wird auf chipID gespeichert
          console.log("RFID Loaded: ", chipID);
          rfidInput.value = null;          // inputfeld wird gecleart
        }

        let found: boolean = false;
        const workers = this.appService.getAllWorkers();
        for (let x = 0; x < workers.length; x++) {
          user = workers[x];
          let ciCoInfo = new CiCoInfo;
          // console.log("user.apiData.rfid: ", user.apiData.rfid);                     // zeigt alle RFIDs
          if (username && user.apiData.username === username ||
              chipID && user.apiData.rfid && user.apiData.rfid.toLowerCase() === chipID.toLowerCase()) {               // if chipID stimmt bei einem User überein
            found = true;
            if (forcedState != null && forcedState || user.apiData.checkedIn == false) {                                      // ist der User ausgecheckt?
              isCheckedIn = true;                                                       // wird dann eingecheckt Terminal Wissen
              ciCoInfo.message = user.apiData.caption + " " + this._translate.instant("LOGGED_IN_SUCCESSFULLY");
            } else {                                                                    // Ausgecheckt
              isCheckedIn = false;                                                      // wird dann ausgecheckt Terminal Wissen
              ciCoInfo.message = user.apiData.caption + " " + this._translate.instant("LOGGED_OUT_SUCCESSFULLY");
            }
            if (this.appService.getInterfaceAttendanceDetailed()) {
              ciCoInfo.workTimeShow = true;
              ciCoInfo.todoTimeShow = true;
              ciCoInfo.breakTimeShow = true;
            }
            let checkInOutRes = new PfCiCoResource(new CiCo);
            checkInOutRes.apiData.in = isCheckedIn;
            checkInOutRes.apiData.worker = user;
            console.log("User: ", checkInOutRes.apiData.worker);
            console.log("checkInOutRes: ", checkInOutRes);
            checkInOutRes.apiData.worker.value = user.apiData._id;
            checkInOutRes.store(this.apiConnection)                                     // hier wird das erste mal der ci über die api geschickt
              .then((storedCiCoRes) => {
                console.log("storedCiCoRes: ", storedCiCoRes);
                // this.appService.getAudioError().play(); //TODO
                for (let y = 0; y < workers.length; y++) {
                  let userT: PfUserResource = workers[y];
                  if (userT.apiData._id === storedCiCoRes.apiData.worker.value) {
                    userT.apiData.checkedIn = storedCiCoRes.apiData.in;                 // hier wird der ci in der app gespeichert, fals alles gut geht
                    if (storedCiCoRes.apiData.in == true) {
                      userT.apiData.currentcicotyp = storedCiCoRes.apiData.attendancecategory;
                      this.appService.$notifyWorkersChanged.next();
                      setTimeout(() => userT.apiData["stateA"] = "checkedIn", 200);
                    } else {
                      userT.apiData.currentcicotyp = null;
                      userT.apiData["stateA"] = "checkedOut";
                      setTimeout(() => this.appService.$notifyWorkersChanged.next(), 500);
                    }
                    this.appService.setCiCoTriggeringWorker(userT)
                    this.appService.makeBackgroundTimeout(userT);
                  }
                }
                let tempWorkday: string = storedCiCoRes.apiData.workday.href;
                let day: Day = new Day();
                day._url = tempWorkday;
                let dayRes: PfDayResource = new PfDayResource(day);
                dayRes.load(this.apiConnection)
                  .then((loadedDayRes: PfItemResource<Day>) => {
                    ciCoInfo.workTime = loadedDayRes.apiData.sumAttendance;
                    ciCoInfo.breakTime = loadedDayRes.apiData.sumBreak;
                    if(loadedDayRes.apiData.sumBreak == 0){
                      ciCoInfo.breakTimeShow = false;
                    }
                    ciCoInfo.todoTime = loadedDayRes.apiData.workdayLength - loadedDayRes.apiData.sumAttendance;
                    if(ciCoInfo.todoTime <= 0){
                      ciCoInfo.todoTime = 0;
                    }
                    console.log("DayRs: ", loadedDayRes.apiData);
                    console.log("Cico saved at PF successfully");
                    resolve (ciCoInfo);
                  })
                  .catch(() => {
                    ciCoInfo.breakTimeShow = false;
                    ciCoInfo.workTimeShow = false;
                    ciCoInfo.todoTimeShow = false;
                    resolve (ciCoInfo);
                  });
              })
              .catch((e) => {
                console.log("Can not saved CiCo at PF successfully");
                console.log(e);
                console.log(e.message);
                this.appService.getAudioError().play();
                ciCoInfo.breakTimeShow = false;
                ciCoInfo.workTimeShow = false;
                ciCoInfo.todoTimeShow = false;
                if (this.appService.getInterfaceAttendanceCiCo() == false){
                  ciCoInfo.message = "CHECK_IS_NOT_ALLOWED";
                } else {
                  ciCoInfo.message = "CHECK_CAN_NOT_SAVED";
                }
                reject (ciCoInfo);
              });
            break;
          }
        }
        if (found == false) {
          ciCoInfoGeneral.message = this._translate.instant("UNKNOWN_USER_RFID") + ": '" + chipID + "'";
          resolve (ciCoInfoGeneral);
        }
      }
    });
  }

}

export class CiCoInfo {

  message: string;
  messageShow: boolean;
  workTime: any;
  workTimeShow: boolean;
  breakTime: any;
  breakTimeShow: boolean;
  todoTime: any;
  todoTimeShow: boolean;

  constructor() {
    this.messageShow = false;
    this.workTimeShow = false;
    this.breakTimeShow = false;
  }
}
